import { SectionData } from '~/lib/contentful/custom-types';
import { Container } from '~/old-marketing/components/Container';
import { Section } from '~/old-marketing/components/sections/Section';
import { SectionActions } from '~/old-marketing/components/sections/SectionActions';
import { SectionTitle } from '~/old-marketing/components/sections/SectionTitle';

const TEMPLATE_KEY = 'worthless-studios-cta';

export type WorthlessStudiosCTASectionTemplateProps = Pick<
  SectionData,
  'actions' | 'backgroundImages' | 'id' | 'title'
> & {
  isSubsection?: boolean;
};

export const WorthlessStudiosCTASectionTemplate = ({
  actions,
  backgroundImages,
  id,
  isSubsection,
  title,
}: WorthlessStudiosCTASectionTemplateProps) => {
  const backgroundImage = backgroundImages?.[0];
  return (
    <Section
      css={{
        backgroundColor: '$pigeon800',
        backgroundImage: `url("${backgroundImage?.file.url}")`,
        backgroundSize: 'cover',
        paddingY: 92,
      }}
      id={id}
      templateKey={TEMPLATE_KEY}
    >
      <Container>
        {title && (
          <SectionTitle
            css={{
              marginBottom: 32,
              color: '$white',
              textAlign: 'center',
            }}
            isSubsection={isSubsection}
            size="heading-48"
          >
            {title}
          </SectionTitle>
        )}

        {actions && (
          <SectionActions
            actions={actions}
            css={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'stretch',

              a: {
                minWidth: 248,

                '&:last-child': {
                  marginTop: 24,
                  marginLeft: 0,
                  color: '$pigeon300',
                },
              },

              '@laptop': {
                flexDirection: 'row',
                justifyContent: 'center',

                a: {
                  '&:last-child': {
                    marginTop: 0,
                    marginLeft: 32,
                  },
                },
              },
            }}
          />
        )}
      </Container>
    </Section>
  );
};

WorthlessStudiosCTASectionTemplate.templateKey = TEMPLATE_KEY;
